module.exports = __webpack_public_path__ + "static/media/fav.5fb74f0e.svg";